import { observer } from 'mobx-react';
import { GroupOrParticipantResource } from '../DeepLinks/DeepLinksBody/InviteParticipantModal/Types';
import User from './User';
import { Fragment } from 'react';

export interface Props {
  newGroupsAndParticipants: ReadonlyArray<GroupOrParticipantResource>;
  removeGroup: (id: number) => void;
  removeParticipant: (id: number) => void;
}

function SelectedUsers({ newGroupsAndParticipants, removeGroup, removeParticipant }: Props) {
  return newGroupsAndParticipants.map((groupOrParticipant) => (
    <Fragment key={groupOrParticipant.payload.id}>
      <User
        removeGroup={removeGroup}
        removeParticipant={removeParticipant}
        groupOrParticipant={groupOrParticipant}
      />
    </Fragment>
  ));
}

export default observer(SelectedUsers);
